module.exports = __webpack_public_path__ + "3c1e0666f51d71ff1e3a918adf06aa2e.svg";